module.exports = __webpack_public_path__ + "assets/img/LTC030.58f7133c.png";